module.exports = __webpack_public_path__ + "static/media/Мурзагулова Ж., Мурзагулов Р. (НУ).281678b6.pdf";